// extracted by mini-css-extract-plugin
export default {"root":"DownloadDropdown__root--1SfIq"};